import React from "react";

function EpOverlayLoader(props) {
 
  return (
    
    <div className="ep-loader-outr">
    <div className="ep-loader">
      <div className="ep-spin-loader"></div>      
      <section className="emx-loader mr-3">        
        <svg width="30" height="37" viewBox="0 0 30 37" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_73_24" maskUnits="userSpaceOnUse" x="0" y="0" width="30" height="37">
          <path d="M30 0H0V36.1765H30V0Z" fill="white"/>
          </mask>
          <g mask="url(#mask0_73_24)">
          <path d="M29.3775 10.7827L26.0409 3.47409L13.8724 8.97732L5.20875 0L0 5.21422L12.7177 17.9453L29.3775 10.7827Z" fill="white"/>
          <path d="M0.62085 25.3937L3.95936 32.7022L16.1276 27.2007L24.7897 36.1765L30 30.9622L17.2824 18.2329L0.62085 25.3937Z" fill="white"/>
          </g>
        </svg>

      </section>

         {props.language === "en" ? <div className="ep-loader-text">
           {props.text}
          </div>: <div className="ep-loader-ar-text">
          {props.text}
      </div>}
      
    </div>
    <div className="ep-loader-bg"></div>
  </div>
 
  );
}


export default EpOverlayLoader;